// Simple alternative for ImmutableJS

type ReadonlyObject<V> = Readonly<{ [key: string]: V }>;

export function readonlyMapFromJs<V>(object: ReadonlyObject<V>): ReadonlyMap<string, V> {
  const newMap = new Map<string, V>();

  for (const key of Object.keys(object)) {
    newMap.set(key, object[key]);
  }

  return newMap;
}

export function readonlyMapToJs<V>(map: ReadonlyMap<string, V>): ReadonlyObject<V> {
  const object = {};

  for (const [key, value] of map) {
    object[key] = value;
  }

  return object;
}

export function readonlyMapFilter<K, V>(map: ReadonlyMap<K, V>, cb: (value: V, key: K) => boolean): ReadonlyMap<K, V> {
  const newMap = new Map<K, V>();
  for (const [key, value] of map) {
    if (cb(value, key)) {
      newMap.set(key, value);
    }
  }
  return newMap;
}

export function readonlyMapSet<K, V>(map: ReadonlyMap<K, V>, key: K, value: V): ReadonlyMap<K, V> {
  if (map.get(key) === value) {
    return map;
  }
  const newMap = new Map<K, V>(map);
  newMap.set(key, value);
  return newMap;
}

export function readonlyMapRemove<K, V>(map: ReadonlyMap<K, V>, key: K): ReadonlyMap<K, V> {
  if (!map.has(key)) {
    return map;
  }

  const newMap = new Map<K, V>(map);
  newMap.delete(key);
  return newMap;
}

export function readonlyMapIsEmpty<K, V>(map: ReadonlyMap<K, V>): boolean {
  return map.size === 0;
}
